import picturefill from "picturefill";
import lazySizes from "lazysizes";
import "lazysizes/plugins/object-fit/ls.object-fit";
import { throttle } from "throttle-debounce";
import log from "helpers/log";

import componentManager from "helpers/components";
import clientManager from "helpers/client";

import Slider from "components/slider";
import HeroSlider from "components/slider-hero";
import MobileSlider from "components/slider-mobile";
import Map from "components/map";
import Masonry from "components/masonry";

//const $ = window.jQuery

const App = () => {
  let comps = null;
  let client = null;

  let init = () => {
    client = clientManager();
    client.update();

    comps = componentManager([Slider, HeroSlider, MobileSlider, Map, Masonry]);
    comps.register();

    document.addEventListener("DOMContentLoaded", docReady);
    window.addEventListener("resize", throttle(300, onResize), false);

    picturefill();
  };

  let docReady = (e) => {
    //console.log($("body"))
    comps.onInit(client.get());

    $(".nav-trigger").on("click", function (e) {
      $(".header-nav").toggleClass("open");
      $(".js-site").toggleClass("open-nav");
      $(this).toggleClass("close");
      e.preventDefault();

      $(".footer-socialmedia, .footer-signet")
        .not(".cloned")
        .clone()
        .appendTo(".header-nav");
      $(".footer-socialmedia, .footer-signet").addClass("cloned");
    });

    $(".read-more-btn").on("click", function () {
      $(this).parent().toggleClass("expanded");
    });

    if (!checkCookie()) {
      setTimeout(function () {
        $(".cookiebar").removeClass("hidden");
      }, 1000);
    }

    $(".cookiebar .button").on("click", function (e) {
      e.preventDefault();
      $(".cookiebar").addClass("hidden");
      setCookie("cookiesaccepted", "Cookies Accepted", 30);
    });

    function setCookie(cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }

    function checkCookie() {
      var cookiesaccepted = getCookie("cookiesaccepted");
      if (cookiesaccepted != "") {
        return true;
      } else {
        return false;
      }
    }
  };

  let onResize = (e) => {
    client.update();
    log.info(`Resized to ${client.get().width}px`);
    comps.onResize(client.get());

    if (client.get().width > 1120) {
      $(".header .footer-socialmedia, .header .footer-signet").remove();
      $(".header-nav").removeClass("open");
    }
  };

  return { init };
};

export default App;



// WEBPACK FOOTER //
// public/content/themes/farrach/src/js/container/app.js